import styled from 'styled-components';

export const ToolbarWrapper = styled.div`
  color: ${(props) => props.theme.colors.grayBlue};
  height: 100%;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  padding: 0;
  flex: 1 1 0;
  min-width: 0;
  overflow-x: auto;
  overflow-y: hidden;
  scrollbar-color: auto;
  scrollbar-width: auto;

  @supports not selector(::-webkit-scrollbar-thumb) {
    scrollbar-color: #525d65 #101315;
  }

  &::-webkit-scrollbar {
    height: 14px;
  }

  &::-webkit-scrollbar:horizontal {
    height: 14px;
  }

  &::-webkit-scrollbar-track {
    background-color: #101315;
  }

  &::-webkit-scrollbar-button {
    display: none;
    width: 0;
    height: 0;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background: linear-gradient(90deg, #525d65 0%, #424d55 35%, #293539 100%) !important;
    border: 2px solid #101315;
  }
`;
